import { CSSProperties } from "react";
import { CommunityRichText } from "./CommunityRichText";

type Props = {
    type: 'line' | 'rich';
    title: string;
    description: string;
    limit?: number;
    value: string;
    onChange: (value: string) => void;
    style?: CSSProperties;
}

export const CommunityInput = ({ type = 'line' , title, description, limit, value, onChange, style }: Props) => {

    return (
        <div className="community-form__input" style={style}>
            <span className="title">{title}</span>
            { type === 'line' ? (
                <input 
                    type="text" 
                    value={value}
                    onChange={(e) => {
                        const val = e.target.value;
                        onChange(val.slice(0, limit));
                    }}
                />
            ):(
                <CommunityRichText
                    value={value}
                    onChange={onChange}
                />
            )}
            <div className="footer">
                <span>{description}</span>
                { limit && (
                    <span>{value.length}/{limit}</span>
                )}
            </div>
        </div>
    )
}